import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ViewPickup() {
  const navigate = useNavigate();
  const { pickup_id } = useParams(); // coming from /view-pickup/:pickup_id
  const [pickup, setPickup] = useState(null);

  useEffect(() => {
    const fetchPickup = async () => {
      try {
        const res = await axios.get(
          `/auth/pickup-history/item/${pickup_id}`
        );
        console.log("API Response for pickup:", res.data); // full object
        console.log("Keys in pickup object:", Object.keys(res.data)); // check field names
        setPickup(res.data);
      } catch (error) {
        console.error("Failed to fetch pickup details", error);
      }
    };
    fetchPickup();
  }, [pickup_id]);


  if (!pickup) {
    return <div className="text-center p-6">Loading pickup data...</div>;
  }

  return (
    <section className="px-2 sm:px-1 md:px-6 lg:px-8 py-4">
      <div className="bg-white shadow-lg rounded-xl p-4 w-full max-w-2xl mx-auto">
        <div className="bg-green-600 text-white text-center py-4 rounded-t-lg text-2xl font-medium sm:text-wrap">
          View Pickup History
        </div>

        <div className="p-6">
          <div className="mb-4">
            <span className="bg-green-100 text-green-700 font-semibold px-4 rounded-full flex justify-self-end text-sm shadow">
              Pickup ID: {pickup_id}
            </span>
            <p className="text-black-500 mt-1 flex justify-center text-lg">
              Pickup Info
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4 text-gray-700">
            <div><span className="font-bold">Customer Id:</span> {pickup.cust_id}</div>
            <div><span className="font-bold">Barcode:</span> {pickup.barcode}</div>
            <div><span className="font-bold">Pickup Status:</span> {pickup.pickup_status}</div>
            <div><span className="font-bold">First Name:</span> {pickup.first_name}</div>
            <div><span className="font-bold">Last Name:</span> {pickup.last_name}</div>
            <div><span className="font-bold">Email:</span> {pickup.email}</div>
            <div><span className="font-bold">Phone:</span> {pickup.phone}</div>
            <div><span className="font-bold">Country:</span> {pickup.country}</div>
            <div><span className="font-bold">Street Address:</span> {pickup.street_address}</div>
            <div><span className="font-bold">City:</span> {pickup.city}</div>
            <div><span className="font-bold">State/Province:</span> {pickup.state}</div>
            <div><span className="font-bold">Zip:</span> {pickup.zip}</div>
            <div><span className="font-bold">Estimated Bags:</span> {pickup.estimated_bags}</div>
            <div><span className="font-bold">Schedule:</span> {pickup.schedule}</div>
            <div><span className="font-bold">Pickup Date:</span>
              {pickup.pickup_date ? new Date(pickup.pickup_date).toDateString() : "Not set"}
            </div>
            <div><span className="font-bold">Pickup Time:</span> {pickup.pickup_time}</div>
            <div><span className="font-bold">Payment Method:</span> {pickup.payment_method}</div>
            <div className="sm:col-span-2"><span className="font-bold">Instructions for Driver:</span> {pickup.driver_instructions}</div>
            <div className="sm:col-span-2"><span className="font-bold">Assigned to:</span> {pickup.driver_assigned || "Not yet assigned"}</div>
          </div>

          <div className="flex justify-end mt-2">
            <button
              onClick={() => navigate("/DriverPickupHistory")}
              className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
